var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lead-category-icon-container",style:({ borderColor: _vm.color })},[_c('div',{staticClass:"lead-category-icon-background",style:({ backgroundColor: _vm.color, opacity: 0.1 })}),_c('span',{staticClass:"pa-2",style:({ fontSize: _vm.size, color: _vm.color })},[_vm._v(" "+_vm._s(_vm.code)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }